import { RENDERER_TYPES } from "../../../enums";

const USERS_LIST_COLUMNS = [
  {
    title: "Name",
    field: "firstName",
    dataType: "string",
    rendererType: RENDERER_TYPES.FULL_NAME_WITH_AVATAR,
  },
  { title: "Email", field: "email", dataType: "string" },
  { title: "Role", field: "role", dataType: "string" },
  { title: "", rendererType: RENDERER_TYPES.ACTION, align: "right" },
];

export { USERS_LIST_COLUMNS };
